import client from '@lib/http/client'
import { ReadFilterType, SpamFilterType } from '@pages/Leads/routes/Leads/types'
import { AxiosError } from 'axios'
import QueryString from 'qs'
import useSWR from 'swr'

import { Lead } from './types'

export type LandingData = {
  identifier: string
}

export type FetchParams = {
  page: number
  pageSize: number
  search?: string
  created_at_min?: number | null
  created_at_max?: number | null
  source_uuid?: string
  group_uuid?: string
  source_type?: string
  is_spam?: SpamFilterType
  is_read?: ReadFilterType
}

export type GetLeadsResponse = {
  collection: Lead[]
  pagination: {
    counter: {
      current: number
      total: number
    }
  }
}

export const useGetLeads = ({
  page,
  pageSize,
  search,
  is_spam,
  created_at_max,
  created_at_min,
  source_type,
  source_uuid,
  group_uuid,
  is_read
}: FetchParams) => {
  const params = QueryString.stringify({
    limit: pageSize,
    page,
    'filters[search]': search,
    'filters[is_spam]': is_spam,
    'filters[created_at_min]': created_at_min,
    'filters[created_at_max]': created_at_max,
    'filters[source_type]': source_type,
    'filters[source_uuid]': source_uuid,
    'filters[group_uuid]': group_uuid,
    'filters[is_read]': is_read
  })

  const fetcherWithTimeout = (url: string) =>
    client.get(url, { timeout: 30000 }).then(res => res.data)

  const { data, isLoading, mutate, error } = useSWR<
    GetLeadsResponse,
    AxiosError
  >(`leads/search-v2?${params}`, fetcherWithTimeout)

  const modifiedData = {
    ...data,
    collection: data?.collection.map((lead: Lead) => ({
      ...lead,
      identifier: lead.id
    }))
  } as GetLeadsResponse

  return { data: modifiedData, isLoading, mutate, error }
}
